// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","brand":"Navbar_brand__PzlM-","links_list":"Navbar_links_list__KauXu","active":"Navbar_active__+dvfu"};